export const OPTHINES = {
  voteName: 'composition',
  // 此类型活动只需要更改aid, tid
  aid: '15',
  tid: '275',
  mustSearch: 'Button',
  buttonBg: '#9f1c2e',
  title: '劳动之美·惟德惟勤 主题征文比赛',
  subtitle: '劳动之美·惟德惟勤 主题征文比赛',
  themeColor: {
    activeBgColor: '#9f1c2e',
    inactiveBgColor: '#eeeeee',
  },
  tabs: [
    {
      tabName: '活动首页',
      tabPath: '/0117LDZW/First',
    },
    {
      tabName: '我要投稿',
      tabPath: '/0117LDZW/User',
    },
  ],
  Grades: [
    '一年级',
    '二年级',
    '三年级',
    '四年级',
    '五年级',
    '六年级',
    '初一',
    '初二',
    '初三',
    '高一',
    '高二',
    '高三',
    '大一',
    '大二',
    '大三',
    '大四',
  ],
};
